import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrganisation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 19V9c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 7h4V5.825a1.975 1.975 0 0 1 .575-1.4l1-1c.383-.383.858-.575 1.425-.575.567 0 1.042.192 1.425.575l1 1a1.975 1.975 0 0 1 .575 1.4V11h4c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19zm2 0h2v-2H5v2zm0-4h2v-2H5v2zm0-4h2V9H5v2zm6 8h2v-2h-2v2zm0-4h2v-2h-2v2zm0-4h2V9h-2v2zm0-4h2V5h-2v2zm6 12h2v-2h-2v2zm0-4h2v-2h-2v2z",
		fill: "currentColor"
	})
});
export default SvgOrganisation;
